import React, {PropTypes} from 'react';
import CaptainPaymentListItemContainer from './CaptainPaymentListItemContainer.jsx';

const CaptainPaymentList = ({
  payments
}) => (
  <div>
    {payments.length
      ? <div className="animated fadeIn">
          <hr />
          <div className="list-group no-border no-justify-content">
            <h4 className="list-heading"
                style={{ "margin-bottom": 20 }} >{'Payment Log'}</h4>
            {payments.map((payment, index) => (
              <div key={index}>
                <hr style={{ "margin-top": 5, "margin-bottom": 5 }} />
                <CaptainPaymentListItemContainer key={index}
                    {...payment} />
              </div>
            ))}
          </div>
        </div>
      : null
    }
  </div>
);

CaptainPaymentList.propTypes = {
  payments: PropTypes.arrayOf(PropTypes.object)
};

CaptainPaymentList.defaultProps = {
  payments: []
};

export default CaptainPaymentList;



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/CaptainPaymentList.jsx